import { RootState } from '@reducers';

export const selectCorporateHealthQuoteBuy = (state: RootState) => state.corporateHealthQuoteBuyRouteReducer;
